/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginTokens } from '../../models/login-tokens';
import { LoginWithCode } from '../../models/login-with-code';

export interface LoginWithCode$Params {
      body: LoginWithCode
}

export function loginWithCode(http: HttpClient, rootUrl: string, params: LoginWithCode$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginTokens>> {
  const rb = new RequestBuilder(rootUrl, loginWithCode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginTokens>;
    })
  );
}

loginWithCode.PATH = '/rest/user/login/code';
